import { Sparkles } from "lucide-react";
import TypingIndicator from "./TypingIndicator";
import { useEffect, useState } from "react";

interface GeneratingOverlayProps {
  isVisible: boolean;
}

const messages = [
  "Analyzing your request...",
  "Creating your checklist...",
  "Adding helpful details...",
  "Almost done..."
];

const GeneratingOverlay = ({ isVisible }: GeneratingOverlayProps) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!isVisible) {
      setMessageIndex(0);
      return;
    }
    
    const interval = setInterval(() => {
      setMessageIndex(prev => (prev + 1) % messages.length);
    }, 2000);
    
    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/90 backdrop-blur-md animate-fade-in-fast">
      <div className="flex flex-col items-center gap-6 p-8">
        <div className="relative">
          <div className="w-14 h-14 rounded-2xl bg-secondary flex items-center justify-center">
            <Sparkles className="h-6 w-6 text-foreground" />
          </div>
          <div className="absolute -inset-1 rounded-2xl border-2 border-foreground/10 border-t-foreground/60 animate-spin" style={{ animationDuration: '1.2s' }} />
        </div>
        <div className="text-center space-y-3">
          <p className="text-base font-medium text-foreground animate-pulse-subtle" key={messageIndex}>
            {messages[messageIndex]}
          </p>
          <TypingIndicator className="justify-center" />
        </div>
      </div>
    </div>
  );
};

export default GeneratingOverlay;